import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Button, Icon, Modal, Spin
} from 'antd';
import Tab from '../home/tab/index';
import SingleEcodeWf from './SingleEcodeWf';
import util from '../../util/index';
import RadioSort from '../util/RadioSort';

const { getRandom, getAccessToken } = util;
const store = ['ecodeWfStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    ecodeWfPrefixCls: 'ecode-wf'
  }
  constructor(props) {
    super(props);
    this.state = {
      orderby: 'createdate',
    }
  }
  componentDidMount() {
    const { orderby } = this.state;
    const { ecodeWfStore: { getCaseList } } = this.props;
    getCaseList({
      demotype: 'workflowChart',
      orderby,
    });
  }
  componentWillUnmount() {
    this.setState({ orderby: '' });
  }
  download = (id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { orderby } = this.state;
    const { ecodeWfStore: { download, getCaseList }  } = this.props;
    download(folderId).then((data) => {
      window.open(url);
      getCaseList({
        demotype: 'workflowChart',
        orderby,
      });
    })
  }
  collection = appId => {
    const { orderby } = this.state;
    const { ecodeWfStore: { setStars, getCaseList, starsLoading } } = this.props;
    !starsLoading && setStars({appId}).then(data => data.msg !== '未登录' && getCaseList({
      demotype: 'workflowChart',
      orderby,
    }));;
  }
  renderList = () => {
    const { orderby } = this.state;
    let { ecodeWfStore: { caseList, getCaseList }, ecodeWfPrefixCls } = this.props;
    // caseList = toJS(caseList);
    const content = caseList.map((list) => {
      return (
        <SingleEcodeWf 
          data={list}
          key={list.id}
          onDownload={this.download}
          onStars={this.collection}
          onChange={() => {
            getCaseList({
              orderby,
              demotype: 'workflowChart',
            });
          }}
        />
      )
    })
    return (<Row className="ecode-wf-single-table-body">
      {content}
    </Row>)
  }
  onChange = value => {
    const { ecodeWfStore: { getCaseList } } = this.props;
    this.setState({orderby: value});
    getCaseList({
      orderby: value,
      demotype: 'workflowChart',
    });
  }
  render() {
    let { ecodeWfStore: { caseList, setState }, prefixCls, getMore, ecodeWfPrefixCls } = this.props;
    const { orderby } = this.state;
    caseList = toJS(caseList);
    const sortList = [{
      label:  <span>
                最新
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'createdate',
    }, {
      label:  <span>
                最热
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'downloadcounts',
    }, {
      label:  <span>
                访问量
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'visits',
    }];
    if (caseList.length > 0) return (
      <div className={`${prefixCls}-body-con`}>
        <Tab title="流程应用" span={24} offset={0} getMore={() => typeof getMore === 'function' && getMore('workflowChart')} />
        <RadioSort
          datas={sortList}
          value={orderby}
          className="main-workflow-sort"
          onChange={this.onChange}
        />
        {this.renderList()}
      </div>
    );
    return (<div/>)
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/main/EcodeWf.js